<app-spinner></app-spinner>
<!-- <router-outlet></router-outlet> -->
<div class="container-fluid mt-2 ms-0">
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
    <h4 class="fw-bold mb-2 mb-md-0">Zone and Ward Mapping</h4>

    <div class="d-flex gap-2">
      <button class="btn d-flex hover-light align-items-center"
        style="background-color: #226CE0;padding: 5px 8px; border-radius: 6px !important;" (click)="map('map')"
        *ngIf="!mapFlag">
        <img src="../../../../assets/img/cfc/services/Plus.svg" alt="plus" class="me-1"
          style="width: 16px; height: 16px;">
        <span class="text-white">Add New Ward</span>
      </button>

      <button class="btn d-flex align-items-center export"
        style="background-color: darkgreen;padding: 5px 8px; border-radius: 10px !important;" (click)="map('excel')"
        *ngIf="!excelFlag">
        <img src="../../../../assets/img/cfc/services/Plus.svg" alt="plus" class="me-1"
          style="width: 16px; height: 16px;">
        <span class="text-white">Add Ward by Excel</span>
      </button>

      <button class="btn d-flex align-items-center back"
        style="background-color: #302f2f;padding: 5px 8px; border-radius: 10px !important;" (click)="map('')"
        *ngIf="mapFlag || excelFlag">

        <span class="text-white"> <span class="p-1">&larr;</span>Back to List</span>
      </button>
    </div>
  </div>


  <div class="d-flex justify-content-between align-items-center mb-3">
    <div style="font-weight: 400; font-size: 20px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <circle cx="12" cy="12.5" r="9" stroke="black" stroke-width="2" />
        <path d="M16.5 12.5H12.25C12.1119 12.5 12 12.3881 12 12.25V9" stroke="black" stroke-width="2"
          stroke-linecap="round" />
      </svg>
      <span class="rule" style="font-weight: 500; font-style: normal;">Ward Mapping</span>
    </div>

    <div class="col-12 col-md-6 d-flex justify-content-md-end" *ngIf="listFlag">
      <div class="input-group" style="max-width: 250px; width: 100%;">
        <span class="input-group-text bg-white border-end-0">
          <img src="../../../../assets/img/cfc/services/Icon.svg" alt="icon" style="width: 16px; height: 16px;">
        </span>
        <input type="text" class="form-control" placeholder="Search Ward" [(ngModel)]="searchText"
          (input)="onSearchChange()">
      </div>
    </div>
  </div>


  <div class="table-responsive" *ngIf="listFlag">
    <table class="table table-bordered w-100 tableshadow">
      <thead class="table table-light">
        <tr>
          <th>Zone</th>
          <th>Ward</th>
          <th>Mohalla</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of pagedZoneList">
          <td><span class="zone">{{ element.zone }}</span></td>
          <td>{{ element.word }}</td>
          <td>{{ element.mohalla }}</td>
          <td> <button class="me-1 edit" (click)="onEdit(addEscalationModal,element)">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <g clip-path="url(#clip0_582_5824)">
                  <path
                    d="M7.83325 3.16665H3.16659C2.81296 3.16665 2.47382 3.30713 2.22378 3.55718C1.97373 3.80723 1.83325 4.14637 1.83325 4.49999V13.8333C1.83325 14.1869 1.97373 14.5261 2.22378 14.7761C2.47382 15.0262 2.81296 15.1667 3.16659 15.1667H12.4999C12.8535 15.1667 13.1927 15.0262 13.4427 14.7761C13.6928 14.5261 13.8333 14.1869 13.8333 13.8333V9.16665M12.8333 2.16665C13.0985 1.90144 13.4582 1.75244 13.8333 1.75244C14.2083 1.75244 14.568 1.90144 14.8333 2.16665C15.0985 2.43187 15.2475 2.79158 15.2475 3.16665C15.2475 3.54173 15.0985 3.90144 14.8333 4.16665L8.49992 10.5L5.83325 11.1667L6.49992 8.49999L12.8333 2.16665Z"
                    stroke="#1E1E1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_582_5824">
                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button class="delete" (click)="deleteAreaMaping(element)">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z"
                  stroke="#F52525" stroke-width="1.5" stroke-linecap="round" />
                <path
                  d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971"
                  stroke="#F52525" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap" *ngIf="listFlag">
    <span style="color: #6D6D6D; font-size: 14px;">
      Showing {{ getStartIndex() }}<span>-</span>{{ getEndIndex() }} of {{ totalRecords }} mapped wards
    </span>

    <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
      <label class="me-1">Per page:</label>
      <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
        <option *ngFor="let size of pageList" [value]="size">{{ size }}</option>
      </select>

      <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()" [disabled]="currentPage === 1">&lt;</button>

      <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

      <button class="btn-sm fw-bold px-3 py-1" (click)="nextPage()"
        [disabled]="currentPage === totalPages">&gt;</button>
    </div>
  </div>

</div>

<div class="tab-pane fade show" *ngIf="mapFlag">
  <div class="row mt-4 mb-3 justify-content-end">
    <div class="col-md-4 col-sm-12 d-flex flex-column flex-sm-row">
      <input type="text" class="form-control me-sm-2 mb-2 mb-sm-0" [(ngModel)]="add_row"
        placeholder="Enter number to add" />
      <button class="sub" (click)="add()">Add</button>
    </div>
  </div>

  <div class="row mb-2 d-none d-md-flex" style="margin-top: 50px;">
    <div class="col-4 font-bold mb-2" style="font-size: 16px;">Zone<span class="text-danger">*</span></div>
    <div class="col-4 font-bold mb-2" style="font-size: 16px;">Ward<span class="text-danger">*</span></div>
    <div class="col-4 font-bold mb-2" style="font-size: 16px;">Mohalla<span class="text-danger">*</span></div>
  </div>

  <div class="row responsive-input-row mb-3" *ngFor="let element of allArea; let i = index">
    <div class="col-12 d-block d-md-none fw-bold mb-1">Zone<span class="text-danger">*</span></div>
    <div class="col-md-4 col-12 mb-2">
      <ng-select [items]="allZone" bindLabel="value" bindValue="code" [multiple]="false" placeholder="Select Zone"
        [(ngModel)]="element['zone_cd']" [selectableGroup]="true" [selectableGroupAsModel]="false"
        [closeOnSelect]="true" name="rela">
      </ng-select>
    </div>

    <div class="col-12 d-block d-md-none fw-bold mb-1">Ward<span class="text-danger">*</span></div>
    <div class="col-md-4 col-12 mb-2">
      <input type="text" class="form-control" [(ngModel)]="element['word']" placeholder="Enter Ward" />
    </div>

    <div class="col-12 d-block d-md-none fw-bold mb-1">Mohalla<span class="text-danger">*</span></div>
    <div class="col-md-4 col-12 mb-2">
      <input type="text" class="form-control" [(ngModel)]="element['mohalla']" placeholder="Enter Mohalla" />
      <div class="d-flex justify-content-end mt-2">
        <button class="delete" (click)="deleteRow(i)">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
            <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
            <path
              d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z"
              stroke="#F52525" stroke-width="1.5" stroke-linecap="round" />
            <path
              d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971"
              stroke="#F52525" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </div>

    <!-- <div class="col-2 mb-2 d-flex"><input type="text" class="form-control" [(ngModel)]="element['block']" placeholder="Enter Block" /> <button class="btn btn-danger"
                            (click)="deleteRow(i)" ><i class="fa fa-trash" aria-hidden="true"></i></button></div> -->
  </div>
  <br>
  <div class="row">
    <div class="col-12 text-center">
      <button class="sub" (click)="submit()">Submit</button>
    </div>
  </div>
</div>
<div class="tab-pane fade show" *ngIf="excelFlag" style="margin-top: 50px;">
  <form name="form" (ngSubmit)="f.form.valid && submitExcel(f)" #f="ngForm">

    <div class="row mb-2 d-none d-md-flex">
      <div class="col-4" style="font-size: 16px; font-weight: 500;">Select Zone<span class="text-danger">*</span></div>
      <div class="col-4 text-center" style="font-size: 16px; font-weight: 500;">Export Excel Format</div>
      <div class="col-4" style="font-size: 16px; font-weight: 500;">Upload Excel File<span class="text-danger">*</span>
      </div>
    </div>

    <div class="row responsive-excel-form">
      <div class="col-12 fw-bold mb-1 d-block d-md-none">Select Zone<span class="text-danger">*</span></div>
      <div class="col-md-4 col-12 mb-2">
        <ng-select [items]="allZone" bindLabel="value" bindValue="code" [multiple]="false" placeholder="Select Zone"
          [(ngModel)]="obj['zone_cd']" [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
          name="zone" #zone="ngModel" required>
        </ng-select>
        <div *ngIf="f.submitted && zone.invalid" class="error-message">
          <span *ngIf="zone.errors?.['required']" style="color: red;">
            Zone Type is required.
          </span>
        </div>
      </div>

      <!-- <div class="col-12 fw-bold mb-1 d-block d-md-none">Export Excel Format</div>
      <div class="col-md-4 col-12 text-center mb-2 text-sm-start">
        <button class="btn " style="color: #226CE0;font-size: 15px;" (click)="export()" type="button"><u>Download</u></button>
      </div> -->
      <div class="col-12 fw-bold mb-1 d-block d-md-none">Export Excel Format</div>

      <div class="col-md-4 col-12 mb-2 text-start text-md-center">
        <button class="btn" style="color: #226CE0; font-size: 15px;" (click)="export()" type="button">
          <u>Download</u>
        </button>
      </div>



      <div class="col-12 fw-bold mb-1 d-block d-md-none">Upload Excel File<span class="text-danger">*</span></div>
      <div class="col-md-4 col-12 mb-2">
        <input type="file" class="form-control" [(ngModel)]="obj['file']" (change)="onFileChange($event)"
          (click)="onClick($event)" placeholder="Select file" accept=".xlsx" name="exfile" #exfile="ngModel" required />
        <div *ngIf="f.submitted && exfile.invalid" class="error-message">
          <span *ngIf="exfile.errors?.['required']" style="color: red;">
            Excel File is required.
          </span>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 text-center">
        <span *ngIf="f.submitted && !f.form.valid" style="color: red;" class="font-weight-bold">
          OPPS !! - Fill All Required Fields
        </span>
      </div>
      <div class="col-12 text-center mt-4">
        <button type="submit" class="sub">Submit</button>
      </div>
    </div>

  </form>
</div>


<ng-template #addEscalationModal let-modal>
  <div class="modal-content">

    <div class="modal-header">
      <div>
        <h3 class="modal-title">Update Zone/ward/mohalla </h3>
        <p class="mb-0">Enter details to update entry.</p>
      </div>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
          <path d="M17.6333 32.3646L32.3666 17.6354M17.6333 17.6354L32.3666 32.3646" stroke="black" stroke-width="1.5"
            stroke-linecap="round" />
        </svg>
      </button> -->
    </div>

    <div class="modal-body">

      <div class="modal-row">

        <br>
        <div class="row mb-2">
          <div class="col-4 font-bold mb-2">Zone<span class="text-danger">*</span></div>
          <div class="col-4 font-bold mb-2">Ward<span class="text-danger">*</span></div>
          <div class="col-4 font-bold mb-2">Mohalla<span class="text-danger">*</span></div>

        </div>
        <div class="row">
          <div class="col-4 font-bold mb-2"><ng-select [items]="allZone" bindLabel="value" bindValue="code"
              [multiple]="false" placeholder="Select Zone" [(ngModel)]="selected['zone_cd']" [selectableGroup]="true"
              [selectableGroupAsModel]="false" [closeOnSelect]="true" name="rela">
            </ng-select>
          </div>
          <div class="col-4 mb-2"><input type="text" class="form-control" [(ngModel)]="selected['word']"
              placeholder="Enter Ward" /></div>
          <div class="col-4 mb-2 d-flex"><input type="text" class="form-control" [(ngModel)]="selected['mohalla']"
              placeholder="Enter Mohalla" /> </div>
        </div>
        <br>

      </div>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn cancel" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn add" (click)="updateZoneMapping()">Update</button>
    </div>

  </div>
</ng-template>